module.exports = __webpack_public_path__ + "static/media/amigoo_pet_inverted.eab537c2.svg";